import { Box, Typography, Link } from '@mui/material'
import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { useExternalApp } from '../../../../../../../hooks'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  title: {
    ...typography.heading.h5,
    fontWeight: typography.fontWeightMedium,
    color: palette.grey.shade[100],
    marginBottom: spacing(2)
  },
  subtitle: {
    ...typography.body.s,
    fontWeight: typography.fontWeightBold,
    color: palette.grey.shade[100],
    marginBottom: spacing(1)
  },
  body: {
    ...typography.body.s,
    color: palette.grey.shade[100],
    marginBottom: spacing(1.2)
  },
  finalBody: {
    ...typography.body.s,
    color: palette.grey.shade[100],
    marginTop: spacing(3)
  }
}))

const BenefitsPanel = ({
  'data-test': testAttr = 'retention-benefits-panel'
}) => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()
  return (
    <Box data-test={testAttr}>
      <Typography className={classes.title}>
        Canceling your plan today means losing your benefits
      </Typography>
      <Typography className={classes.subtitle}>Unlimited Access</Typography>
      <Typography className={classes.body}>
        Full access to the Mind Tools toolkit of 2,400+ resources.
      </Typography>
      <Typography className={classes.subtitle}>
        Professional Coaching
      </Typography>
      <Typography className={classes.body}>
        Access to Mind Tools&apos; own team of qualified career coaches,
        offering confidential, expert guidance.
      </Typography>
      <Typography className={classes.subtitle}>Expert Interviews</Typography>
      <Typography className={classes.body}>
        We have 200+ exclusive interviews with leading subject experts, giving
        unique insights and inspiration.
      </Typography>
      <Typography className={classes.finalBody}>
        ...and much more, {' '}
        <Link
          href={getMtUrl('about')}
          color='primary'
          underline='always'
          data-test={`${testAttr}-benefits-link`}
        >
          see all your benefits here
        </Link>
      </Typography>
    </Box>
  )
}

export default BenefitsPanel
